
export const TOKENS = {
    black: "#111111",
    white: "#FCFCFC",
    lightGray: "#F0F0F0",
    magenta: "#E5007E",
    w: 700,
    h: 580,
    radius: 3,
};
